export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9915.355a4dae.jpg";